var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 26,
    viewBox: "0 0 6 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 27031"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 256",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "#6283ED"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 257",
    cx: 3,
    cy: 13,
    r: 3,
    fill: "#6283ED"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 258",
    cx: 3,
    cy: 23,
    r: 3,
    fill: "#6283ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipses);
export default __webpack_public_path__ + "static/media/ellipses.07a07bcaccca270e3fc0d9b786b22b96.svg";
export { ForwardRef as ReactComponent };